import { TableColumn } from '../../../shared/models/table-column.model';

export const rapportErreurSyncDialogColumn: TableColumn[] = [
    { field: 'element', header: 'Élément ou Code à barres' },
    { field: 'message', header: 'Message' },
];
